import React, { useState } from 'react';

import { useAppInfo } from 'AppState';
import { clientsData } from 'b2b/Clients/clientsData';
import useHandleClientClick from 'b2b/useHandleClientClick';
import SelectBox from 'components/Inputs/SelectBox';

export default function ClientDropdown({size="large",color}) {
  const clients = clientsData.map((client) => client.name)
  const [selectedClient, setSelectedClient] = useState(clients[0])
  const {stateHome} = useAppInfo();
  const handleClientClick = useHandleClientClick();
  const {clientSelected} = stateHome;
  console.log(clientSelected)
  return (
    <>
        <SelectBox
        label="Select Client"
        variant="outlined"
        size={size}
        width="100%"
        borderColor={color}
        labelColor={color}
        textColor={color}
        iconColor={color}
        options={clients}
        value={clientSelected}
        onChange={(e,v) => handleClientClick(v)}
        />
    </>
  )
}
